<template>
	<section class="reviews">
    	<div class="container">
    	    <div class="title">
                <slot></slot>
    	    </div>
    	</div>

        <ul>
        	<template v-for="n in 3">
        		<li class="little_monito_score" v-for="provider in providers"><img class="logo" :src="provider.logo" />
                    <element-circle-score :score="provider.score" :width="48" :stroke="4" :size="15"></element-circle-score>
                    <a :href="provider.url">Read the review</a></li>  
        	</template>   s
       	</ul>

        </section>
</template>

<script>
	import CircleScore from './CircleScore.vue'
	export default {
		props:['providers'],
		components : {
			'element-circle-score' : CircleScore,
		}
	}
</script>

<style lang="scss">
    .little_monito_score {
        .monito_score svg {
            top: 2px !important;
            left: 2px !important;
        }

        .score {
            top: -1px !important;
            left: 0px!important
        }
    }
</style>

<style lang="scss" scoped>

    .reviews {
        margin-top: 60px;
        margin-bottom: 50px;
        height: 380px;
        width: 100vw;
        overflow: hidden;

        @media ($tablet_portrait) {
            margin-top: 50px;
            margin-bottom: 50px;
            height: 350px;
            overflow: hidden;
            width: 100%;
        }

        @media ($mobile) {
            margin-top: 30px;
            margin-bottom: 10px;
            height: 350px;
            overflow: hidden;
            width: 100%;
        }
    }

    .container {
        width: 1030px;
        margin: 0 auto;


        h1 {
            text-align: left;
            max-width: 55%;
        }

        @media ($tablet_portrait) {
            width: 90%;
            margin-left: auto;
            margin-right: auto;

            h1,span {
                display: block;
                text-align: center;
                max-width: 95%;
                margin-left: auto;
                margin-right: auto;
            }
        }
    }

	ul {
		list-style: none;
        margin: 60px 0 0 0 ;
        width: 100vw;
        display: flex;

        z-index: 1005;
        padding: 0;
        position: relative;

        @keyframes slide {
            0% {left: -10vw;}
            100% { left: -100vw;}
        }   

        animation-name: slide;
        animation-duration: 75s;
        animation-timing-function: linear;  
        animation-iteration-count: infinite;

        @media ($tablet_portrait) {
            animation-duration: 20s;
             @keyframes slide {
                0% {left: -10vw;}
                100% { left: -200vw;}
            }   
        }

        @media ($mobile) {
            animation-duration: 24s;
             @keyframes slide {
                0% {left: -10vw;}
                100% { left: -200vw;}
            }   
        }

        @media (min-width: 991px) {
            &:hover {
                -webkit-animation-play-state: paused;
                -moz-animation-play-state: paused;
                -o-animation-play-state: paused;
                animation-play-state: paused;
            }
        }
    }
	
	li {
		position: relative;
        flex: none;
		min-width: 130px;
		height: 100px;
    	border-radius: 20px;
    	background-color: #fff;
    	margin-left: 10px;
    	display: inline-block;
    	margin-right: 12px;
    	-webkit-box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.04);
   		-moz-box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.04);
    	box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.04);

    	a { @media (max-width: 990px) {
    		  position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100px;
              text-indent: -10000px;
              font-size: 1px;
            }
    	}

    	.monito_score {
    		position: absolute;
    		top: -38px;
    		right: -28px;
    		background: #fff;
    		border: 6px solid #F8F8F8; 
    		border-radius: 30px;
    		width: 52px;
    		height: 52px;

            @media ($mobile) {
                border-color: #efefef;
            }
    	}



		img.logo {
			height: 36px;
			width: auto;
    		padding: 30px 35px 25px 35px;

            @media ($mobile) {
                height: 36px;
            }
		}

        @media (min-width: 991px) {

          a {
            display: none;
          }
		  &:hover {
              	transform: scale(1.05);
              	transition: all ease 0.2s;
              	height: 155px;
              	position: relative;
              	top: -20px;
              	
              	a {
              		display: block;
              		background: #ff9a00;
                    width: calc(100% - 30px);
                    display: block;
                    position: absolute;
                    bottom: -2px;
                    opacity: 0;
                    left: 15px;
                    color: #fff;
                    @keyframes opacity_btn {
                            
                        0% {opacity: 0; bottom: -2px;}
                        100% { opacity: 1; bottom: 15px;}
                    }   
                    animation-name: opacity_btn;
                    animation-duration: 0.25s;
                    animation-timing-function: ease; 
                    animation-fill-mode: forwards; 
                    text-decoration: none;
                    font-weight: 700;
                    font-size: 14px;
                    text-align: center;
                    padding: 14px 0;
                    border-radius: 10px;
                    letter-spacing: 0.03em;
                    -webkit-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
                    -moz-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
                    box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
                    cursor: pointer;
    
                    &:hover {
                    	background-color:#ff8100;
                    }
              	}
            }
        }
	}
</style>


// WEBPACK FOOTER //
// src/components/WidgetProviders.vue